import React, { useEffect } from 'react';
import { useState } from 'react';
import { useAuth } from '../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../../commons/Loading';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import axios from 'axios';
import CollaboratorsAdminPresentational from './CollaboratorsAdminPresentational';
import './AdminCollaborators.scss';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const CollaboratorsAdmin = ({ profile }) => {
  const [{ newToken } = {}] = useAuth();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [t] = useTranslation('CONTACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  const [query, setQuery] = useQueryParams({
    profileStatus: withDefault(
      StringParam,
      localStorage.getItem('profileStatus')
    ),
    search: withDefault(StringParam, localStorage.getItem('profileSearch')),
    offset: NumberParam,
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
  });

  const { search, offset, limit, profileStatus } = query;

  useEffect(() => {
    const fetchCollaborators = async () => {
      showLoading();

      const response = await axios({
        method: 'get',
        url: `${process.env.REACT_APP_API_URL}/collaborators/${profile._id}`,
        headers: {
          Authorization: newToken,
        },
        params: {
          search,
          offset,
          limit,
          profileStatus,
        },
      });

      hideLoading();

      if (response instanceof Error) {
        return alert.error(t('COMMON:GENERIC_ERROR'));
      }

      const { data = [], headers = {} } = response;

      setData(data);
      setTotal(Number(headers['x-total-count']));
      hideLoading();
    };

    fetchCollaborators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, offset, limit, profileStatus]);

  function onFilter(query) {
    if (
      (query.search && query.search !== search) || // first search
      (search && query.search === '') || // search deleted
      (query.profileStatus && query.profileStatus !== profileStatus) ||
      (query.limit && query.limit !== limit)
    ) {
      query.offset = 0; // return to first page
    }
    setQuery(query);
  }

  return (
    <CollaboratorsAdminPresentational
      data={data}
      total={total}
      query={query}
      onFilter={onFilter}
    />
  );
};

export default CollaboratorsAdmin;
